import React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X, Maximize2 } from 'lucide-react';

export function ImageLightbox({ src, alt, width, height, className = '', openLabel, closeLabel }) {
  return (
    <DialogPrimitive.Root>
      <DialogPrimitive.Trigger asChild>
        <button
          type="button"
          aria-label={openLabel}
          className="group relative block w-full cursor-zoom-in rounded-3xl focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4"
        >
          <img src={src} alt={alt} width={width} height={height} className={className} />
          <span
            aria-hidden="true"
            className="absolute top-4 right-4 flex items-center justify-center w-11 h-11 rounded-full bg-black/40 text-white backdrop-blur-sm opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity duration-300"
          >
            <Maximize2 className="w-5 h-5" />
          </span>
        </button>
      </DialogPrimitive.Trigger>

      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-10 focus:outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 duration-300"
        >
          <DialogPrimitive.Title className="sr-only">{alt}</DialogPrimitive.Title>
          <DialogPrimitive.Close asChild>
            {/* Clicking anywhere around the image closes it */}
            <div className="absolute inset-0 cursor-zoom-out" aria-hidden="true" />
          </DialogPrimitive.Close>
          <img
            src={src}
            alt={alt}
            width={width}
            height={height}
            className="relative max-h-full max-w-full w-auto h-auto object-contain rounded-xl shadow-2xl"
          />
          <DialogPrimitive.Close
            aria-label={closeLabel}
            className="absolute top-4 right-4 md:top-6 md:right-6 flex items-center justify-center w-12 h-12 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            <X className="w-6 h-6" />
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
